export const JIRA_LINK = "https://jira.cybernest.com"

export const priorities = [
    { value: "Medium", label: "Medium" },
    { value: "High", label: "High" },
    { value: "Highest", label: "Highest" },
]

export const tasksStatuses = [
    { value: "Selected for Development", label: "Selected for Development" },
    { value: "In Progress", label: "In Progress" },
    { value: "Ready For Demo", label: "Ready For Demo" },
    { value: "Ready for QA", label: "Ready for QA" },
    { value: "Defects", label: "Defects" }
]
